/* INVOICE DATA */
export const GET_INVOICES_LIST = "GET_INVOICES_LIST";
export const SET_INVOICES_LIST = "SET_INVOICES_LIST";
export const ADD_INVOICE = "ADD_INVOICE";
export const PATCH_INVOICE = "PATCH_INVOICE";

/* INVOICE ACTIONS */
export const DELETE_INVOICE = "DELETE_INVOICE";

/* INVOICE CHOISE */
export const GET_INVOICE_CHOICE = "GET_INVOICE_CHOICE";
export const SET_INVOICE_CHOICE = "SET_INVOICE_CHOICE";

/* INVOICE BY OFFER */
export const POST_INVOICE_BY_OFFER = "POST_INVOICE_BY_OFFER";

/* INVOICE BY SALARY */
export const POST_INVOICE_BY_SALARY = "POST_INVOICE_BY_SALARY";

/* INVOICE DATA PROFILE */
export const GET_INVOICE_PROFILE = "GET_INVOICE_PROFILE";
export const SET_INVOICE_PROFILE = "SET_INVOICE_PROFILE";
export const UPDATE_INVOICE_PROFILE = "UPDATE_INVOICE_PROFILE";
export const SET_ERROR_INVOICE_PROFILE = "SET_ERROR_INVOICE_PROFILE";

/* LOADER */
export const SHOW_INVOICE_LIST_LOADER = "SHOW_INVOICE_LIST_LOADER";
export const HIDE_INVOICE_LIST_LOADER = "HIDE_INVOICE_LIST_LOADER";
export const INVOICE_PROFILE_LOADER = "INVOICE_PROFILE_LOADER";
export const INVOICE_MAKE_LOADER = "INVOICE_MAKE_LOADER";

/* STATUSES */
export const SET_STATUSES = "SET_STATUSES";

/* FILTER DATA */
export const GET_INVOICES_FILTER_DATA = "GET_INVOICES_FILTER_DATA"
export const SET_INVOICES_FILTER_DATA = "SET_INVOICES_FILTER_DATA"

export const GET_AGGREGATED_STAFF_DATA = "GET_AGGREGATED_STAFF_DATA"
export const SET_AGGREGATED_STAFF_DATA = "SET_AGGREGATED_STAFF_DATA"
export const LOADER_AGGREGATED_STAFF_DATA = "LOADER_AGGREGATED_STAFF_DATA"

export const ADD_CUSTOM_INVOICE = "ADD_CUSTOM_INVOICE"